module.exports = __webpack_public_path__ + "static/img/zngk_p2.76572c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/zngk_p2.png
// module id = IG73
// module chunks = 19